import {Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, viewChild} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {WjFlexGrid, WjGridModule} from '@mescius/wijmo.angular2.grid';
import {WjFlexGridFilter, WjGridFilterModule} from '@mescius/wijmo.angular2.grid.filter';
import {Wijmo, WjGridUtils} from '../lib/wjgrid-utils';
import {DataType} from '@mescius/wijmo';
import {ColumnCollection, ColumnGroup, FlexGrid} from '@mescius/wijmo.grid';
import {AccountGridService, AppAccountColumnDeclaration} from '../views/account-grid/account-grid-helper';
import {WjGridColumnChooser} from '../lib/wjgrid-columchooser';
import {AppGridViewService} from '../service/app-grid-view.service';

const GridTestColumnsShort: AppAccountColumnDeclaration[] = [
    { header: 'Group 1', columns: [
            { attribute: 'aptp' },
            { attribute: 'renewalLimit' },
        ]
    },
    { header: 'Group 2', columns: [
            "finalPilStatus",
            "expiringCurrency",
        ]
    },
    "renewalGnwp"
];

// const GridTestColumns = AccountGridService.expandToWijmoColumnDeclarations(GridTestColumnsShort);
// console.log(GridTestColumns);

// const TestColumnsFlat: WijmoColumnDeclaration[] = [];
// WjGridUtils.treeWalk(GridTestColumns as ColumnGroup[], (c) => {
//     if (c.binding) TestColumnsFlat.push(c as WijmoColumnDeclaration)
// });

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        FormsModule,
        WjGridModule,
        WjGridFilterModule
    ],
    template: `
        <div class="layout-vbox" style="gap: 10px">
            <wj-flex-grid #grid
                          (initialized)="onGridInitialized(grid, gridFilter)"
                          [showSelectedHeaders]="Wijmo.HeadersVisibility.All" [allowDragging]="Wijmo.AllowDragging.Columns"
                          [showMarquee]="true" width="100%" height="100%"
                          [allowResizing]="Wijmo.AllowResizing.Both" [autoRowHeights]="false" [quickAutoSize]="false"
                          [headersVisibility]="Wijmo.HeadersVisibility.All"
                          [selectionMode]="Wijmo.SelectionMode.CellRange" [isReadOnly]="false"
                          [autoGenerateColumns]="false"
            >
                <wj-flex-grid-filter #gridFilter></wj-flex-grid-filter>
            </wj-flex-grid>

            <div class="layout-hbox" style="gap: 10px">
                <fluent-button (click)="serializeLayout(grid)">Serialize Layout</fluent-button>
                <fluent-button (click)="deserializeLayout(grid)">Deserialize Layout</fluent-button>
                <fluent-button (click)="swapCols(grid)">Swap Cols</fluent-button>
            </div>

            <textarea name="textarea" #layoutJsonEl>abc</textarea>
        </div>`,
    styles: `
        wj-flex-grid {
            width: 800px;
            height: 600px;
        }
        textarea {
            width: 100%;
            height: 200px;
            overflow: auto;
            white-space: pre-wrap;
            word-break: break-all;
            border: 1px solid #ccc;
        }
    `
})
export class TestFlexGridLayoutComponent {

    protected readonly Wijmo = Wijmo;

    private readonly layoutJsonEl = viewChild.required<ElementRef<HTMLTextAreaElement>>('layoutJsonEl');

    constructor() {
    }

    async onGridInitialized(grid: WjFlexGrid, gridFilter: WjFlexGridFilter) {
        await AccountGridService.configureGridColumns(grid, GridTestColumnsShort, undefined);
        grid.itemsSource = this.generateTestData(grid, 50);
        WjGridColumnChooser.addColumnChooser("test.flex.grid", grid);
        setTimeout(() => grid.autoSizeRows(0, grid.columnHeaders.rows.length - 1, true), 10);
    }

    private swapGridCols(cols: ColumnCollection, i1: number = 0, i2: number = 1) {
        const temp = cols[i1];
        cols[i1] = cols[i2];
        cols[i2] = temp;
    }

    swapCols(grid: WjFlexGrid) {
        // const cols = grid.columns;
        // const newCols = cols.slice();
        let temp: ColumnGroup;
        grid.deferUpdate(() => {
            // this.swapGridCols(grid.columns, 0, 1);
            const cg = grid.columnGroups.slice()
            temp = cg[0];
            cg[0] = cg[1];
            cg[1] = temp;
            grid.columnGroups = cg;
        });
        //this.swapGridCols(newCols, 2, 3);
        // grid.deferUpdate(() => {
        //     grid.columns.clear();
        //     newCols.forEach(col => {
        //         if (typeof col.width === 'number') col.width += 10;
        //         grid.columns.push(col)
        //     });
        // });
    }

    customColumnLayoutSerializer(grid: FlexGrid): string {
        const layout = AppGridViewService.takeColumnLayoutSnapshot(grid);
        return JSON.stringify(layout, null, 2);
    }

    serializeLayout(grid: WjFlexGrid) {
        // const layoutJavascript = grid.columnLayout;
        const layoutJavascript = this.customColumnLayoutSerializer(grid);
        this.layoutJsonEl().nativeElement.value = layoutJavascript;
    }

    deserializeLayout(grid: WjFlexGrid) {
        const layout = this.layoutJsonEl().nativeElement.value;
        const layoutValues = JSON.parse(layout);
        const x = AccountGridService.configureGridColumns(grid, layoutValues)
    }

    private generateRandomTestValue(dataType: DataType): any {
        switch (dataType) {
            case DataType.String: return `Random String ${Math.floor(Math.random() * 100)}`;
            case DataType.Number: return Math.floor(Math.random() * 100);
            case DataType.Date: return new Date(2023, 0, Math.floor(Math.random() * 31) + 1);
            default: return null;
        }
    }

    private generateTestData(grid: FlexGrid, count: number): any[] {
        const data: any[] = [];
        const columns = grid.columns;
        for (let i = 0; i < count; i++) {
            const item: Record<string, any> = {};
            columns.forEach(col => item[col.binding!] = this.generateRandomTestValue(col.dataType!));
            data.push(item);
        }
        return data;
    }
}
